import api from '../utils/api';

const BUSINESS_ID = parseInt(process.env.REACT_APP_BUSINESS_ID, 10);

export const createLead = (data) => {
  return api.post('/leads', {
    ...data,
    business_id: BUSINESS_ID,
  });
};

export const createLeadWithAppointment = (data) => {
  return api.post('/leads/with-appointment', {
    ...data,
    business_id: BUSINESS_ID,
  });
};
